'use strict';

var util = require('./util');

/**
 * @description Use to explicitly set element-scope CSS variables with element scrollHeight values
 * for easy height animation from 0 to "auto" just by switching CSS class
 * Use "height: var(--element-scroll-height)" CSS rule to change height to "auto"
 */

function refresh() {
    document.querySelectorAll('[data-set-scroll-height]').forEach((element) => {
        var $el = $(element);
        var height = $el.prop('scrollHeight');

        if ($el.find('.fragrance-ref').length) {
            height = $el.find('.fragrance-ref').prop('scrollHeight');
            height += $el.find('.filters-desktop__close-cta-wrapper').outerHeight();
        }

        element.style.setProperty('--element-scroll-height', `${height}px`);
        $el.data('element-scroll-height', `${height}px`);
    });

    // IE11 doesn't support setProperty with css variables so I created a custom toggler for the refinements
    if (util.isIE()) {
        $(document).on('toggleDesktopRefinement', function (e, refinement) {
            var $refinement = $(refinement);
            var $refinementValues = $refinement.find('.filters-desktop__refinement-values-wrapper');
            var height = $refinementValues.data('element-scroll-height');
            $refinementValues.css('height', '');

            if ($refinement.hasClass('filters-desktop__refinement--expanded')) {
                $refinementValues.css('height', height);
            }
        });

        $(document).on('clickOutsideFilters', function () {
            var $filtersFesktop = $('.filters-desktop');
            var $refinementValues = $filtersFesktop.find('.filters-desktop__refinement-values-wrapper');

            $refinementValues.css('height', '');
        });
    }
}

function init() {
    refresh();

    $(window).on('resize', refresh);
}

module.exports = {
    init,
    refresh
};
